/**
 * Represents types of date formats in an abstract way (which can be combined with a locale to determine the final format).
 * For permissible values, see https://github.com/moment/luxon/blob/master/docs/formatting.md#presets.
 */
export var DateFormats;
(function (DateFormats) {
    /**
     * 10/14/1983 (en_US); 14/10/1983 (fr)
     */
    DateFormats[DateFormats["DATE_SHORT"] = 0] = "DATE_SHORT";
    /**
     * Oct. 14, 1983 (en_US)
     */
    DateFormats[DateFormats["DATE_MED"] = 1] = "DATE_MED";
    /**
     * 'October 14, 1983' (en_US)
     */
    DateFormats[DateFormats["DATE_FULL"] = 2] = "DATE_FULL";
    /**
     * 09:30 AM (en_US)
     */
    DateFormats[DateFormats["TIME_SIMPLE"] = 3] = "TIME_SIMPLE";
    /**
     * 09:30 AM - Oct. 14, 1983 (en_US)
     * CUSTOM FORMAT
     */
    DateFormats[DateFormats["TIME_SIMPLE_HYPEN_DATE_MED"] = 4] = "TIME_SIMPLE_HYPEN_DATE_MED";
    /**
     * April (en_US)
     * CUSTOM FORMAT
     */
    DateFormats[DateFormats["MONTH"] = 5] = "MONTH";
    /**
     * Apr (en_US)
     * CUSTOM FORMAT
     */
    DateFormats[DateFormats["MONTH_SHORT"] = 6] = "MONTH_SHORT";
    /**
     * Oct. 14 (en_US)
     * CUSTOM FORMAT
     */
    DateFormats[DateFormats["SHORT_WITH_NO_YEAR"] = 7] = "SHORT_WITH_NO_YEAR";
    /**
     * October 2025 (en_US)
     * CUSTOM FORMAT
     */
    DateFormats[DateFormats["MONTH_WITH_YEAR"] = 8] = "MONTH_WITH_YEAR";
    /**
     * Oct '25 (en_US) — short month + two-digit year with leading apostrophe.
     * CUSTOM FORMAT
     */
    DateFormats[DateFormats["MONTH_SHORT_WITH_SHORT_YEAR"] = 9] = "MONTH_SHORT_WITH_SHORT_YEAR";
})(DateFormats || (DateFormats = {}));
//# sourceMappingURL=DateFormats.js.map